// extracted by mini-css-extract-plugin
export var infoRow = "_ni-2";
export var labelContainer = "_ni-0";
export var rightInfo = "_ni-1";